import { useState } from "react";
import { faqData } from "../../../mocks/baogua";

export default function FaqZone() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 md:px-6 py-16 md:py-20">
      <div className="text-center mb-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-emerald-600/10 text-emerald-700 text-sm font-medium px-4 py-1.5">
          <i className="ri-question-line w-4 h-4 flex items-center justify-center"></i> 常见问题
        </span>
        <h2 className="mt-4 font-serif-cn text-2xl md:text-4xl font-black text-[#201d1a]">吃瓜之前，先看这里</h2>
        <p className="mt-3 text-[#201d1a]/60">关于投稿、审核与举报，你关心的问题我们一次讲清楚。</p>
      </div>

      <div className="space-y-3">
        {faqData.map((f, i) => {
          const isOpen = openIdx === i;
          return (
            <div
              key={f.q}
              className={`rounded-2xl border bg-white overflow-hidden transition-colors ${isOpen ? "border-emerald-600/40" : "border-amber-900/10"}`}
            >
              <button
                onClick={() => setOpenIdx(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="font-semibold text-[#201d1a] flex items-center gap-3">
                  <span className={`grid w-7 h-7 rounded-full items-center justify-center text-sm shrink-0 ${isOpen ? "bg-emerald-600 text-white" : "bg-amber-100 text-amber-700"}`}>
                    <i className="ri-question-line w-4 h-4 flex items-center justify-center"></i>
                  </span>
                  {f.q}
                </span>
                <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} w-5 h-5 flex items-center justify-center text-[#201d1a]/50 transition-transform shrink-0`}></i>
              </button>
              {isOpen && (
                <p className="px-5 pb-5 pl-[60px] text-sm text-[#201d1a]/65 leading-relaxed">{f.a}</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}